// Agent authentication.
//
// This module used to mutate the global axios instance — setting
// `axios.defaults.withCredentials` and installing interceptors as an import
// side effect. That made every other service's auth behaviour depend on
// whether this file had been imported yet, and it silently reconfigured axios
// for any third-party code sharing the instance. The 401 redirect now lives on
// the shared apiClient, where it applies to every API call by construction.
import apiClient from "../api/apiClient";

const login = async (agentId, password) => {
  // Clear any existing session cookie first so a failed login can't leave the
  // previous agent signed in.
  await logout();

  const { data } = await apiClient.post("/validate-agent", { agentId, password });
  if (data?.message === "SUCCESS") {
    return { status: "SUCCESS", agent: data.agent };
  }
  return { status: "ERROR", message: data?.message || "Authentication failed" };
};

const logout = async () => {
  try {
    await apiClient.post("/logout");
  } catch (error) {
    // Logging out is best-effort: the cookie may already be gone, and a failure
    // here must never block the login that follows it.
    console.error("Logout failed:", error);
  }
};

const authService = { login, logout };

export default authService;
